var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.downloadToken}},[_c('span',{staticClass:"icon is-small"},[_c('fa',{attrs:{"icon":"cloud-download-alt","fixed-width":""}})],1),_c('span',[_vm._v("Download Token file")])])
}
var staticRenderFns = []

export { render, staticRenderFns }